import * as Yup from 'yup';

import { type FieldSchema, type ValidatorContext } from '../types';

const createCheckboxValidator = (context: ValidatorContext): FieldSchema => {
  const { l, isRequired, requiredMessage } = context;

  let validator = Yup.array().of(Yup.string().required()).ensure().nullable();

  if (isRequired) {
    const message = requiredMessage ?? l('Select at least one option');

    validator = validator.min(1, message).required(message);
  }

  return validator;
};

export default createCheckboxValidator;
